import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { PageErrorBoundary } from '@vivicta/ui';

const applicationOnboardingPage = PageBlueprint.make({
  name: 'onboarding',
  params: {
    path: '/onboarding',
    noHeader: true,
    loader: () =>
      import('./components/ApplicationPortalPage').then(m => (
        <PageErrorBoundary title="Onboarding">
          <m.ApplicationPortalPage />
        </PageErrorBoundary>
      )),
  },
});

const applicationLifecyclePage = PageBlueprint.make({
  name: 'lifecycle',
  params: {
    path: '/applications',
    noHeader: true,
    loader: () =>
      import('./components/ApplicationLifecyclePage').then(m => (
        <PageErrorBoundary title="Applications">
          <m.ApplicationLifecyclePage />
        </PageErrorBoundary>
      )),
  },
});

const subscriptionsPage = PageBlueprint.make({
  name: 'subscriptions',
  params: {
    path: '/subscriptions',
    // Not a sidebar item (no routeRef, title or icon): developers see their
    // subscriptions in Onboarding's checklist; the platform team opens this
    // page by its URL to set up the Identity Vending Machine.
    noHeader: true,
    loader: () =>
      import('./components/SubscriptionsPage').then(m => (
        <PageErrorBoundary title="Subscriptions">
          <m.SubscriptionsPage />
        </PageErrorBoundary>
      )),
  },
});

export default createFrontendPlugin({
  pluginId: 'vivicta-application-portal',
  extensions: [
    applicationOnboardingPage,
    applicationLifecyclePage,
    subscriptionsPage,
  ],
});
